import Typography from "components/typography";
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Colors } from "utils/colors";

interface IProps {
  artistVariant?: boolean;
}
const UpgradeToPro = ({ artistVariant }: IProps) => {
  return (
    <Container>
      <Typography
        color={Colors.grey700}
        size="s"
        weight="medium"
        display="inline"
      >
        Upgrade to Pro/Label Plan to{" "}
        {artistVariant ? "add More artists" : "edit Record Label"}.
      </Typography>
      <LinkText to={"/pricing"}>
        <Typography
          size="s"
          decoration="underline"
          color={Colors.yellow500}
          display="inline"
          ml="0.5"
          weight="medium"
        >
          Upgrade Now{" "}
        </Typography>
      </LinkText>
    </Container>
  );
};

export default UpgradeToPro;

const Container = styled.div`
  width: 25rem;
  border-radius: 4rem 4rem 0rem 4rem;
  background: #fed183;
  padding: 1.1rem 2.2rem;
  display: inline-block;
`;

const LinkText = styled(Link)`
  all: unset;
  cursor: pointer;
`;
